// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"7d7ce560","453":"02b443a1","796":"b1ffa328"}[chunkId] + ".chunk.js";
};